import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { NestApiProvider } from "../../nest-api";
import {
  ResponseBalanceDto,
  ResponseHistoryDto,
  ResponseTypeDto,
  ResponseAddDto,
  ResponseSaveDto,
  ResponseDeleteDto,
  RequestLeaveRequestDto,
  ResponseLeaveCancelSaveDto,
  ResponseLeaveCancelHistoryDto,
  ResponseAddCancelDto,
  ResponseDeleteDraftDto,
  ResponseBalanceDetailDto,
  RequestBalanceDetail,
} from "../dto/leave.dto";
import { ResponseData } from '../../nest-responses';
import { RequestGetLeaveReqApprovalDto, ResponseGetLeaveReqApprovalDto } from '../../gd-only/dto/sf-leave-request.dto';

@Injectable()
export class LeaveSf6Api {

  private readonly service: string = 'attendance';
  private readonly model: string = 'sf6s';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public type(empId: string, lang: string): Observable<ResponseTypeDto> {
    const method: string = 'GET';
    const func: string = 'leave/type';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof empId !== 'undefined' && empId !== null) urlParams.empId = empId;
    if (typeof lang !== 'undefined' && lang !== null) urlParams.lang = lang;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseTypeDto>(method, url, func, params, body);
  }

  public history(empId: string, limit: string | number, skip: string | number): Observable<ResponseHistoryDto> {
    const method: string = 'GET';
    const func: string = 'leave/history';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof empId !== 'undefined' && empId !== null) urlParams.empId = empId;
    if (typeof limit !== 'undefined' && limit !== null) urlParams.limit = limit;
    if (typeof skip !== 'undefined' && skip !== null) urlParams.skip = skip;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseHistoryDto>(method, url, func, params, body);
  }

  public balance(leaveId: string): Observable<ResponseBalanceDto> {
    const method: string = 'GET';
    const func: string = 'leave/balance';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof leaveId !== 'undefined' && leaveId !== null) urlParams.leaveId = leaveId;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseBalanceDto>(method, url, func, params, body);
  }

  public add(payload: any): Observable<ResponseAddDto> {
    const method: string = 'POST';
    const func: string = 'leave/add';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseAddDto>(method, url, params, urlParams, body, null, 150000);
  }

  public updateLeaveBalance(payload: any): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'leave/updateLeaveBalance';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public save(payload: any): Observable<ResponseSaveDto> {
    const method: string = 'POST';
    const func: string = 'leave/save';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseSaveDto>(method, url, params, urlParams, body);
  }

  public delete(payload: any): Observable<ResponseDeleteDto> {
    const method: string = 'POST';
    const func: string = 'leave/delete';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseDeleteDto>(method, url, params, urlParams, body);
  }

  public request(requestno: string): Observable<RequestLeaveRequestDto> {
    const method: string = 'GET';
    const func: string = 'leavecancel/request';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof requestno !== 'undefined' && requestno !== null) urlParams.requestno = requestno;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<RequestLeaveRequestDto>(method, url, func, params, body);
  }

  public leaveCancelHistory(requestNo: string): Observable<ResponseLeaveCancelHistoryDto> {
    const method: string = 'GET';
    const func: string = 'leavecancel/history';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof requestNo !== 'undefined' && requestNo !== null) urlParams.requestNo = requestNo;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseLeaveCancelHistoryDto>(method, url, func, params, body);
  }

  public leaveCancelDetailDate(flag: string, leavereqno: string, reqno?: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'leavecancel/detailDate';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof flag !== 'undefined' && flag !== null) urlParams.flag = flag;
    if (typeof leavereqno !== 'undefined' && leavereqno !== null) urlParams.leavereqno = leavereqno;
    if (typeof reqno !== 'undefined' && reqno !== null) urlParams.reqno = reqno;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, func, params, body);
  }

  public leaveCancelSave(payload: any): Observable<ResponseLeaveCancelSaveDto> {
    const method: string = 'POST';
    const func: string = 'leavecancel/save';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseLeaveCancelSaveDto>(method, url, params, urlParams, body);
  }

  public leaveCancelDeleteDraft(payload: any): Observable<ResponseDeleteDraftDto> {
    const method: string = 'POST';
    const func: string = 'leavecancel/delete';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseDeleteDraftDto>(method, url, params, urlParams, body);
  }

  public leaveCancelAdd(payload: any): Observable<ResponseAddCancelDto> {
    const method: string = 'POST';
    const func: string = 'leavecancel/add';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseAddCancelDto>(method, url, params, urlParams, body);
  }

  public insertLeave(payload: any): Observable<ResponseAddDto> {
    const method: string = 'POST';
    const func: string = 'leave/insertLeave';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseAddDto>(method, url, params, urlParams, body, null, 60000);
  }

  public updateLeave(payload: any): Observable<ResponseSaveDto> {
    const method: string = 'POST';
    const func: string = 'leave/updateLeave';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseSaveDto>(method, url, params, urlParams, body);
  }

  public updatePost(payload: any): Observable<ResponseSaveDto> {
    const method: string = 'POST';
    const func: string = 'leave/updatePost';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseSaveDto>(method, url, params, urlParams, body);
  }

  public leaveBalanceDetail(data: RequestBalanceDetail): Observable<ResponseBalanceDetailDto> {
    const method: string = 'GET';
    const func: string = 'leave/leaveBalanceDetail';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof data.leaveId !== 'undefined' && data.leaveId !== null) urlParams.leaveId = data.leaveId;
    if (typeof data.limit !== 'undefined' && data.limit !== null) urlParams.limit = data.limit;
    if (typeof data.skip !== 'undefined' && data.skip !== null) urlParams.skip = data.skip;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseBalanceDetailDto>(method, url, func, params, body);
  }

  public requestMassiveLeave(requestno: string, empId: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'leave/requestMassiveLeave';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    if (typeof requestno !== 'undefined' && requestno !== null) urlParams.requestno = requestno;
    if (typeof empId !== 'undefined' && empId !== null) urlParams.empId = empId;

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, func, params, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-integrated/services/leave-sf6.api.ts